// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { utils } from '@seedplanner/shared-utils';

export default utils.formatDuration;
